export default "__VITE_ASSET__Cc$a9cnC__"